var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h20v20H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.25 3.901.164.16a5.809 5.809 0 0 1 .515 7.622l4.33 4.39a.833.833 0 0 1-1.108 1.24l-.078-.07-4.334-4.392a5.817 5.817 0 0 1-7.545-.578 5.803 5.803 0 0 1-.002-8.22 5.793 5.793 0 0 1 8.057-.152zM5.37 5.232a4.137 4.137 0 0 0 .003 5.862 4.15 4.15 0 0 0 5.863 0 4.141 4.141 0 0 0 .142-5.705l-.153-.16a4.127 4.127 0 0 0-5.854.003z",
    fill: "#1B3DF2",
    fillRule: "nonzero"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsSearch);
export default __webpack_public_path__ + "static/media/icons-search.08d891d1f8a7fbc5ab16f3e4b0d759f1.svg";
export { ForwardRef as ReactComponent };